import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrFormArrayShimmerComponent } from './form-array/hr-form-array-shimmer.component';
// import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { CardModule } from 'primeng/card';
import { HrMasterDataShimmerComponent } from './master-data/hr-master-data-shimmer.component';

@NgModule({
    declarations: [HrFormArrayShimmerComponent, HrMasterDataShimmerComponent],
    imports: [CommonModule, CardModule],
    exports: [HrFormArrayShimmerComponent, HrMasterDataShimmerComponent],
})
export class HrShimmerModule {}
